import { Divider, Empty, Form, Input, Radio, Select, Typography } from 'antd';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useSelect } from '@refinedev/antd';

export const ModalCreateAssignmentStep1 = () => {
  const params = useParams();
  const classroomId = params.id;
  const form = Form.useFormInstance();

  const type = Form.useWatch('type');

  // The professor-area assignments listing has no search scope server-side, so
  // load the discipline's models in one page and filter locally (below) instead
  // of paginating — otherwise only the first page would be selectable.
  const { selectProps } = useSelect({
    resource: 'professor_area/classroom_assignments',
    meta: {
      classroomId,
      pathTemplate: 'professor_area/classrooms/:classroomId/assignments'
    },
    optionLabel: 'name',
    pagination: { pageSize: 200, mode: 'server' }
  });

  const onChangeType = useCallback(
    (type: 'list' | 'new') => {
      return type === 'new'
        ? form.setFieldValue('evaluation_id', null)
        : form.setFieldValue('description', '');
    },
    [form]
  );

  return (
    <>
      <Typography.Title level={4} className="!mb-8">
        Selecione a atividade
      </Typography.Title>

      <Form.Item
        label="Atividade"
        name="type"
        initialValue="list"
        rules={[
          {
            required: true,
            message: 'Por favor, selecione o tipo de atividade'
          }
        ]}
      >
        <Radio.Group
          options={[
            { label: 'Banco de atividades', value: 'list' },
            { label: 'Nova atividade', value: 'new' }
          ]}
          optionType="button"
          buttonStyle="outline"
          onChange={e => onChangeType(e.target.value)}
        />
      </Form.Item>

      <Divider />

      {type === 'list' && (
        <Form.Item
          label="Modelo de atividade"
          name="evaluation_id"
          rules={[
            {
              required: true,
              message: 'Por favor, selecione o modelo de atividade'
            }
          ]}
        >
          <Select
            {...selectProps}
            showSearch
            filterOption={(input, option) =>
              String(option?.label ?? '')
                .toLowerCase()
                .includes(input.toLowerCase())
            }
            notFoundContent={
              <Empty description="Não há atividades cadastradas para essa disciplina" />
            }
            placeholder="Selecione o modelo"
            allowClear
          />
        </Form.Item>
      )}

      <Form.Item
        label="Nome da atividade"
        name="name"
        rules={[
          {
            required: true,
            message: 'Por favor, insira o nome da atividade'
          },
          { min: 3, message: 'O nome deve ter pelo menos 3 caracteres' }
        ]}
      >
        <Input placeholder="Digite o nome da atividade" />
      </Form.Item>

      {type === 'new' && (
        <Form.Item label="Descrição" name="description">
          <Input.TextArea rows={3} placeholder="Digite uma descrição" />
        </Form.Item>
      )}
    </>
  );
};
